import React from 'react'
import carimg from "../../../assets/images/maruti-breeza.png"

const carDetail = () => {
  return (
    <section>
    <div className='car-detail'>
    <div className="img mt-3">
        <img src={carimg} alt="" srcset="" />
    </div>
    <div className="car-title">
        Maruti Brezza
    </div>
    <div className="car-number">
    DL1N9276
    </div>
    
    
   
    
    </div>

     <div className="refund text-center">
    Refund-of ₹ 7900 initiated
    </div>
    

    </section>
  )
}

export default carDetail